import React from 'react';
import { ToggletipState } from './types';

export const ToggletipContext = React.createContext<ToggletipState | null>(null);
